import React from 'react';

import CustomModal from '../../components/CustomModal';
import { CrossIcon, WarningIcon } from '../../assets/icons';
import Button from '../../components/Button';
import useModalState from '../../context/modal/useModalState';

const DemoDisclaimerModal: React.FC = () => {
    const { closeModal } = useModalState();
    const onClose = () => closeModal('demoDisclaimerModal');

    return (
        <CustomModal
            modalName='demoDisclaimerModal'
            className='status-modal warning-modal'
            overlayClassName='status-modal'
            shouldCloseOnOverlayClick={false}
        >
            <div className='content'>
                <Button onClick={onClose}>
                    <CrossIcon />
                </Button>
                <div className='icon-container'>
                    <WarningIcon />
                </div>
                <div className='status'>Disclaimer</div>
                <div className='message' style={{ padding: '0 24px' }}>
                    This is a demo version with mock data. <br />
                    The product is no longer live.
                </div>
            </div>
        </CustomModal>
    );
};

export default DemoDisclaimerModal;
